module.exports = {
  "country": "IE",
  "artist": "Dana ",
  "song": "All Kinds of everything",
  "year": "1970",
  "place": "1",
  "spotify": "3SJPRPwpF0MTFKPrshBeKM"
};